export default "__VITE_ASSET__303169d4__"